import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { IBatonAuth } from '../models/baton-auth';
import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api/lib/types';
import { Queries } from './appsync-services';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  readonly MY_CONSTANT = LabelConstants;

  constructor(private http: HttpClient) {}

  authenticateUserWithCognito(username, password) {
    const url = environment.urlFetchCognitoToken;
    const params = new HttpParams()
      .set(AppConstants.PARAM_LOGIN_USERNAME, username)
      .set(AppConstants.PARAM_LOGIN_PASSWORD, password);
    const headerObject = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded; charset=UTF-8'
      )
    };
    return this.http.post(url, params, headerObject);
  }

  fetchUserDetails(token) {
    const url = environment.urlFetchUserDetails;
    const options = {
      params: new HttpParams().set('token', token)
    };
    return this.http.get(url, options);
  }

  callValidationService(accessToken: string) {
    const batonUrl = environment.urlBatonValidation;

    // const params = new HttpParams().set('token', accessToken);
    const headerObject = new HttpHeaders().set(
      'Content-Type',
      'application/json;'
    );
    return this.http.post(
      batonUrl,
      { token: accessToken },
      { headers: headerObject }
    );
  }

  callValidationServiceQuery(cognitoToken: string) {
    const validateTokenQuery = new Queries().validateToken;
    const result = API.graphql(graphqlOperation(validateTokenQuery, { token: cognitoToken })) as Promise<GraphQLResult>;
    return result;
  }

  changePassword(batonAuth: IBatonAuth) {
    const url = environment.urlChangePassword;
    const headerObject = new HttpHeaders().set(
      'Content-Type',
      'application/json;'
    );
    const labelUsername = AppConstants.PARAM_BATON_CHANGE_PASS_USERNAME;
    const labelPassword = AppConstants.PARAM_BATON_CHANGE_PASS_PASSWORD;
    const labelNewPassword = AppConstants.PARAM_BATON_CHANGE_PASS_NEW_PASSWORD;

    const params = {
      // username: batonAuth.username,
      // password: batonAuth.password,
      // newPassword: batonAuth.newPassword
    };

    params[labelUsername] = batonAuth.username;
    params[labelPassword] = batonAuth.password;
    params[labelNewPassword] = batonAuth.newPassword;

    return this.http.post(url, params, { headers: headerObject });
  }

}
